// src/pages/HomePage.js
import React, { useState, useContext } from 'react';

import '../css/HomePage.css'; // Import the CSS file for styling
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../FireBase'; // Firestore instance
import Loading from '../components/Loading';
import ImageSlider from '../components/ImageSlider.jsx';

import { AuthContext } from '../context/AuthContext'; // Import AuthContext
import ScrollToTop from '../components/ScrollToTop';

import { Container, Row, Col, Card, Button, Badge, Navbar, Nav, Image } from "react-bootstrap";
import { FaShoppingCart, FaHome, FaList, FaWallet, FaGift, FaBars, FaUserCircle } from "react-icons/fa";
import ProductCard from '../components/productcard.jsx';
import ProductList from '../components/BestSeller.jsx';
import CategoryList from '../components/Categorylist.jsx';
import NewArrival from '../components/NewArrival.jsx';
import Amenities from '../components/Amenities.jsx';
import Faq from '../components/Faq.jsx';
import FeaturedRooms from '../components/FeaturedRooms.jsx';
import MapLocation from '../components/MapComponent.jsx';
import FeaturedPackages from '../components/FeaturedPackages.jsx';
import ClientTestimonials from '../components/Testimonial.jsx';
import FeaturedSightSeeings from '../components/FeaturedSightSeeings.jsx';
import FeaturedOutStationRentals from '../components/FeaturedOutStationRentals.jsx';

const HomePage = () => {
  const [loading, setLoading] = useState(false); // Loading state
  const { currentUser} = useContext(AuthContext);
  
  
 
  if (loading) {
    // Render loading screen
    
    return (
      <div className="loading-screen">
        
      <Loading/>
      </div>
    );
  }

  return (
    <>
      {/* <Carousel /> */}
      <div className="container justify-content-center align-items-center" style={{paddingBottom:'100px'}}>
        <br/>
        <div style={{borderRadius: '30px'}}>
        <ImageSlider />
        </div>
        <br/>
        <FeaturedRooms/>
        <br/>
        <Amenities/>
        <br/>
        <FeaturedPackages/>
       
        {/* <br/>
        <CategoryList/>
        <br/> */}
        
         <br/>
        <FeaturedSightSeeings/>
        <br/>
        <FeaturedOutStationRentals/>
        <br/>
          {/* <ClientTestimonials/> */}
       <Faq/>
       <MapLocation address="Kabili Holidays, 7FCG+449, Attuvampatti, Tamil Nadu 624103"/>
       
      
      </div>
     
    
    </>
  );
};

export default HomePage;
